import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../api"
import type { NotificationCountView } from "./NotificationCountView"

export const getNotificationOpenCountRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, NotificationCountView> = {
	buildUrl: () => "/notification-open-count",
	method: "get",
	path: "/notification-open-count",
}
